import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import React, { useState, useEffect } from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import i18n from 'i18n-js';
import Footer from "@/components/basic/Footer";
import MediaCarousell from "@/components/media/MediaCarousell";
import ItemText from '@/components/basic/ItemText';
import { useSafeAreaInsets } from "react-native-safe-area-context";

export default function ShowItem({ route, navigation, updateItemState }) {
    const insets = useSafeAreaInsets()

    const { taskid, title, nextStep, items, idx, active, restricted, isSimulator } = route.params

     const actions = [
        { icon: 'keyboard-arrow-up', text: idx == 0 ? 'footer.backStep' : 'footer.prevItem', component: idx == 0 ? 'BACK' : 'ShowItem', params: { taskid: taskid, title: title, nextStep: nextStep, items: items, idx: idx - 1, active: active, restricted: restricted, isSimulator: isSimulator } },
        isSimulator 
            ? { icon: '' } 
            : { icon: 'home', text: 'footer.home', component: 'Home' },
        idx == items.length - 1 
            ? (nextStep < 0 
                ? { icon: active && (!restricted || items.every(item => item.done)) ? 'keyboard-arrow-down' : '', text: 'footer.forward', component: 'Finished', params: { taskid: taskid, title: title, isSimulator: isSimulator } } 
                : { icon: !active || !restricted || items.every(item => item.done) ? 'keyboard-arrow-down' : '', text: 'footer.nextStep', component: 'ShowStep', params: { taskid: taskid, idx: nextStep, isSimulator: isSimulator } })
            : { icon: 'keyboard-arrow-down', text: 'footer.nextItem', component: 'ShowItem', params: { taskid: taskid, title: title, nextStep: nextStep, items: items, idx: idx + 1, active: active, restricted: restricted, isSimulator: isSimulator } }
    ]

    const [item, setItem] = useState(items[idx])

    useEffect(() => {
        setItem(items[idx])
        navigation.setOptions({ title: i18n.t('showItemScreen.title') + ' ' + (idx + 1), info: items[idx].title })
    }, [idx])

    const actionChecked = () => {
        const newItem = { ...item, done: !item.done }
        setItem(newItem)
        updateItemState(newItem, idx)
    }

    const icon = active ? { action: actionChecked, checked: item.done } : null

    return (
        <View className="bg-secondary-50 flex-1">
            <ScrollView contentContainerStyle={{ paddingBottom: 120 + insets.bottom }}>
                {item.media.length > 0 && <MediaCarousell uris={item.media} overlays={item.overlays}/>}
                <VStack className="m-3">
                    <ItemText title={item.title} text={item.text} isSimulator={isSimulator}/>
                </VStack>
            </ScrollView>
            <Footer navigation={navigation} actions={actions} icon={icon} />
        </View>
    );
}
